"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Select = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Select"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var YouTubeForm = function YouTubeForm(_ref) {
  var _onChange = _ref.onChange,
      _ref$state = _ref.state,
      _ref$state$url = _ref$state.url,
      url = _ref$state$url === void 0 ? '' : _ref$state$url,
      _ref$state$aspectRati = _ref$state.aspectRatio,
      aspectRatio = _ref$state$aspectRati === void 0 ? '16:9' : _ref$state$aspectRati;
  var aspectRatioOptions = [{
    label: '16:9',
    value: '16:9'
  }, {
    label: '4:3',
    value: '4:3'
  }, {
    label: '1:1',
    value: '1:1'
  }, {
    label: '2:1',
    value: '2:1'
  }];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "mb-1"
  }, "Youtube Embed Code"), /*#__PURE__*/_react["default"].createElement("textarea", {
    className: "form-control",
    rows: 6,
    value: url,
    onChange: function onChange(e) {
      return _onChange({
        url: e.target.value
      });
    }
  })), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Aspect Ratio",
    value: aspectRatio,
    onChange: function onChange(e) {
      return _onChange({
        aspectRatio: e.value
      });
    },
    options: aspectRatioOptions
  }));
};

var _default = YouTubeForm;
exports["default"] = _default;